package app.smartcoding.realrate.presentation.components

import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.text.TextAutoSize
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AccountCircle
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarScrollBehavior
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import app.smartcoding.realrate.domain.model.AuthUser
import app.smartcoding.realrate.localization.LocalStrings
import coil3.compose.SubcomposeAsyncImage

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TopBar(
    scrollBehavior: TopAppBarScrollBehavior,
    onClickAccount: () -> Unit,
    authUser: AuthUser
) {
    TopAppBar(
        scrollBehavior = scrollBehavior,
        title = {
            Text(
                text = "RealRate",
                style = MaterialTheme.typography.headlineLarge,
                maxLines = 1,
                autoSize = TextAutoSize.StepBased(
                    minFontSize = MaterialTheme.typography.titleSmall.fontSize,
                    maxFontSize = MaterialTheme.typography.headlineLarge.fontSize,
                ),
                softWrap = false
            )
        },
        actions = {
            IconButton(onClick = onClickAccount) {
                when (authUser) {

                    AuthUser.Unknown -> {
                        Icon(
                            modifier = Modifier
                                .size(32.dp)
                                .clip(CircleShape),
                            imageVector = Icons.Default.AccountCircle,
                            contentDescription = "User Icon"
                        )
                    }

                    is AuthUser.User -> {
                        SubcomposeAsyncImage(
                            model = authUser.photoUrl,
                            contentDescription = "Profile picture",
                            modifier = Modifier
                                .size(32.dp)
                                .clip(CircleShape),

                            loading = {
                                Icon(
                                    modifier = Modifier
                                        .size(32.dp)
                                        .clip(CircleShape),
                                    imageVector = Icons.Default.AccountCircle,
                                    contentDescription = null,
                                )
                            },

                            error = {
                                Icon(
                                    modifier = Modifier
                                        .size(32.dp)
                                        .clip(CircleShape),
                                    imageVector = Icons.Default.AccountCircle,
                                    contentDescription = "Error loading image",
                                )
                            }
                        )
                    }
                }
            }

        },
    )
}